import Axios from "../helper/axios";
import { urls } from "../constants/constants";

const axios = new Axios();

export default class LiveChatService {
  getLogs(
    pageNo = 1,
    pageSize = 15,
    sort = "",
    filter = "",
    startDate = "",
    endDate = "",
    csv = false,
  ) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patientAudit/getDeletedPatients?page=${pageNo}&size=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}${csv ? `&csv=${csv}` : ""}`,
    };
    return axios.get(option);
  }

  getLogsListSuggestions(
    column,
    value,
    filters = {},
    startDate = "",
    endDate = "",
  ) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patientAudit/columnData?attribute=${column}&value=${value}&filter=${JSON.stringify(
        filters,
      )}${startDate ? `&startDate=${startDate}` : ""}${
        endDate ? `&endDate=${endDate}` : ""
      }`,
    };
    return axios.get(option);
  }

  getSpellingSuggestions(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/conversation/spellCheck`,
      data: data,
    };
    return axios.post(option);
  }

  getQuickReplyList() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/quick-reply`,
      headers: {
        Authorization: `Bearer `,
        Pragma: "no-cache",
      },
    };
    return axios.get(option);
  }

  saveQuickReply(msg, title) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/quick-reply`,
      data: {
        quickMessage: msg,
        quickTitle: title,
      },
    };
    return axios.post(option);
  }

  translateMessage(text, targetLanguage = "en") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/conversation/translate/outbound`,
      data: {
        text,
        targetLanguage,
      },
      headers: {
        "Content-Type": "application/json",
      },
    };
    return axios.post(option);
  }

  getQuickReplyById(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/quick-reply/${id}`,
    };
    return axios.get(option);
  }

  updateQuickReply({ id, quickTitle, quickMessage }) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/quick-reply/${id}`,
      data: { quickMessage, quickTitle },
    };
    return axios.put(option);
  }

  deleteQuickReply(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/quick-reply/${id}`,
    };
    return axios.delete(option);
  }

  updateSelectedChatCount(patientId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/conversation?page=
        1&size=15&patientId=${patientId}&type=activeItem`,
    };
    return axios.get(option);
  }
}
